import { useEffect } from "react";
import { router, usePage } from "@inertiajs/react";
import { toast } from "sonner";

import { Toaster } from "@/components/ui/sonner";
import type { SharedProps } from "@/types";

export default function Flash() {
  const { flash } = usePage<SharedProps>().props;

  useEffect(() => {
    if (flash.notice) toast.success(flash.notice);
    if (flash.alert) toast.error(flash.alert);

    // Avoid flash message re-rendering on browser back/forward buttons
    if (flash.notice || flash.alert) {
      router.reload({ only: ["flash"] });
    }
  }, [flash.notice, flash.alert]);

  return <Toaster />;
}
